module.exports = __webpack_public_path__ + "img/video.bbc0cb26.svg";